const DeviceFlag = require('../../requires/view/ui/device-flag');
const DropdownMenu = require('../../requires/view/ui/dropdown-menu');
const Menu = require('../../requires/view/ui/menu');
const MenuToggelBox = require('../../requires/view/ui/menu-toggle-box');
const ToTop = require('../../requires/view/ui/to-top');
const LineFlatHeight = require('../../requires/view/ui/line-flat-height');
const Selectbox = require('../../requires/view/ui/form/selectbox');
const Placeholder = require('../../requires/view/ui/form/placeholder');
const SimulationResult = require('../../requires/view/ui/simulation-result');
const Anchor = require('../../requires/view/ui/anchor');
const Accodion = require('../../requires/view/ui/accodion');
const Select = require('../../requires/view/ui/select');
const Simulation = require('../../requires/view/ui/simulation');
const ModalWindow = require('../../requires/view/ui/modal-window');
const AmpereSelect = require('../../requires/view/ui/form/ampere-select');
const ValidateContact = require('../../requires/view/ui/form/validate-contact');
const ValidatePostCode = require('../../requires/view/ui/form/validate-post-code');
const ValidateSimulationElectricBill = require('../../requires/view/ui/form/validate-simulation-electric-bill');
const ValidateSimulationElectricityUsage = require('../../requires/view/ui/form/validate-simulation-electricity-usage');
const ValidateSimulationMonth = require('../../requires/view/ui/form/validate-simulation-month');
require('custom-event-polyfill');
require('html5-polyfills/classList');
require('html5-polyfills/dataset');
require('fetch');
require('lodash');
require('Velocity');
require('Velocity.ui');
require('../../vendors/velocity.easeplus');

// create multiple incetance
const createIncetance = (_class, _selector, _opts) => {
  const $$el_ = document.querySelectorAll(_selector);
  const instances = [];
  for(let i_ = 0; $$el_.length > i_; i_++) {
    const arg_ = [ $$el_[i_] ];
    if(_opts) arg_.push(_opts);
    instances.push(new _class(...arg_));
  };
  return instances;
};

// create single incetance
const createSingleIncetance = (_class, _selector, _opts) => {
  const $$el_ = document.querySelectorAll(_selector);
  if(!$$el_.length) return false;
  const arg_ = [$$el_];
  if(_opts) arg_.push(_opts);
  return new _class(...arg_);
};

window.addEventListener('DOMContentLoaded', () => {

  const modules_ = [
    [ DropdownMenu, '.js-dropdown-menu' ],
    [ Menu, '.js-menu' ],
    [ MenuToggelBox, '.js-menu-toggle-box' ],
    [ ToTop, '.js-to-top' ],
    [ LineFlatHeight, '.js-line-flat-height' ],
    [ Selectbox, '.js-selectbox' ],
    [ Placeholder, 'input' ],
    [ SimulationResult, '.js-simulation-result' ],
    [ Anchor, 'a' ],
    [ Accodion, '.js-accodion' ],
    [ Select, '.js-select' ],
    [ AmpereSelect, '.js-ampere-select' ],
    [ ValidateContact, '.js-validate-contact' ],
    [ ValidatePostCode, '.js-validate-post-code' ],
    [ ValidateSimulationElectricBill, '.js-validate-simulation-electric-bill' ],
    [ ValidateSimulationElectricityUsage, '.js-validate-simulation-electricity-usage' ],
    [ ValidateSimulationMonth, '.js-validate-simulation-month' ],
  ];

  new DeviceFlag(document.body);

  modules_.forEach((_arr) => {
    createIncetance(..._arr);
  });

  window.simulation = createIncetance(Simulation, '.js-simulation-electricity-usage', {
    modalId: 'simulation-electricity-usage-1'
  })[0];

  window.modalWindow = createSingleIncetance(ModalWindow, '.js-mw');

});



/** WEBPACK FOOTER **
 ** ./webpack/src/scripts/index.js
 **/